module.exports = __webpack_public_path__ + "img/shangwu.84259ce6.png";